import { Pipe, PipeTransform } from "@angular/core";
import Credential from "../../models/resource-management/credential";
import CredentialType from "../../models/resource-management/credential-type.enum";
import CredentialedResource from "../../models/resource-management/credentialed-resource";
import { formatEnumString } from "../pipe-enum-utils";

@Pipe({
  name: "resourceWithCredentials",
})
export class CredentialedResourcePipe implements PipeTransform {
  /**
   * Takes a datetime and formats it
   */
  transform(value: CredentialedResource, ...args) {
    if (!value) return "";
    let name = value.lastName + ", " + value.firstName;

    if (!value.credentials || value.credentials.length === 0) {
      return name;
    }

    let s = "(";

    value.activeCredentials.forEach((x: Credential) => {
      // include operating as when determining what show
      if (x.operatingAs) {
        if (x.type === 27) {
          s += x.other + ", ";
        } else {
          s += formatEnumString(CredentialType[x.type]) + ", ";
        }
      }
    });

    if (s === "(") {
      return name;
    }

    s = s.substring(0, s.length - 2);
    s += ")";

    name = name + " " + s;

    return name;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/credentialed-resource.pipe.ts